import { type Locale, type WorkQueueBucket, WORK_QUEUE_BUCKET_DEFS } from '@aps/contracts';

/**
 * Admin panel matnlari.
 *
 * Navbat guruhlarining yorliqlari BU YERDA EMAS — ular kontraktda
 * (`WORK_QUEUE_BUCKET_DEFS`), chunki server ham, klient ham bir xil
 * guruh nomini ko'rsatishi kerak. Ikki joyda yozilsa ajralib ketadi.
 */
const UZ = {
  appTitle: 'AvtoPartShop',
  appSubtitle: 'Boshqaruv paneli',

  loginTitle: 'Kirish',
  loginHint: "Login va parolni Owner beradi. Ochiq ro'yxatdan o'tish yo'q.",
  loginField: 'Login',
  passwordField: 'Parol',
  totpField: 'Bir martalik kod',
  totpHint: 'Owner uchun — autentifikator ilovasidagi 6 raqam',
  signIn: 'Kirish',
  signingIn: 'Kirilmoqda…',
  signOut: 'Chiqish',

  workQueue: 'Ish navbati',
  workQueueEmpty: "Navbat bo'sh. Hozircha bajariladigan vazifa yo'q.",
  bucketEmpty: "Bu guruhda vazifa yo'q.",
  back: 'Orqaga',
  refresh: 'Yangilash',
  loadMore: 'Yana yuklash',
  loading: 'Yuklanmoqda…',

  colOrder: 'Buyurtma',
  colCustomer: 'Mijoz',
  colShop: "Do'kon",
  colStatus: 'Status',
  colTotal: 'Summa',
  colWaiting: 'Kutmoqda',
  colEta: 'Muddat',

  shopUnset: 'Tanlanmagan',
  etaUnset: 'Belgilanmagan',
  overdue: "Muddati o'tgan",
  itemsCount: (n: number): string => `${String(n)} pozitsiya`,
  waitingDays: (n: number): string => `${String(n)} kun`,
  waitingHours: (n: number): string => `${String(n)} soat`,
  waitingMinutes: (n: number): string => `${String(n)} daqiqa`,
  oldest: 'Eng eskisi',

  errorTitle: 'Xatolik',
  retry: 'Qayta urinish',
  navQueue: 'Ish navbati',
  navOrders: 'Buyurtmalar',
  navPayments: "To'lovlar",
  navProducts: 'Tovarlar',
  navImport: 'Import',
  navReference: "Ma'lumotnomalar",
  navDashboard: 'Boshqaruv paneli',
  navConsignments: 'Xitoy partiyalari',
  navAudit: 'Audit jurnali',
  navUsers: 'Xodimlar',
  navProductNew: "Tovar qo'shish",
  navCategories: 'Kategoriya va brend',
  navSearchLog: 'Qidiruv jurnali',
  navGarage: 'Garaj statistikasi',
  navRegions: "Hududlar bo'yicha",
  navGroupGeneral: 'Umumiy',
  navGroupCatalog: 'Katalog',
  navGroupAnalytics: 'Tahlil',
  navGroupShops: "Do'konlar",
  navGroupSystem: 'Tizim',
  navLabel: 'Asosiy menyu',
  toastStatusPush: 'Status yangilandi · mijozga push ketdi',
  toastStatusNoPush: 'Status yangilandi · push yubormaydi, mijozga o‘zingiz ayting',
  toastSaved: 'Saqlandi',
  toastAdded: 'Qo‘shildi',
  toastDeleted: 'O‘chirildi',
  toastSettingSaved: 'Sozlama saqlandi',
  toastNoteSaved: 'Izoh saqlandi',
  toastFailed: 'Bajarilmadi',
  toastPaymentConfirmed: 'To‘lov tasdiqlandi',
  toastProductSaved: 'Tovar saqlandi',
  toastProductArchived: 'Tovar arxivga o‘tkazildi',
  toastProductCreated: 'Tovar yaratildi. Endi rasm qo‘shishingiz mumkin.',
  toastShopAssigned: 'Do‘kon biriktirildi',
  consignmentShipmentCount: (n: number): string => `${String(n)} ta jo‘natma`,
  consignmentNoShipments: 'Bu partiyada jo‘natma yo‘q',
  consignmentNew: 'Yangi partiya',
  consignmentCreate: 'Ochish',
  consignmentCreated: 'Partiya ochildi',
  consignmentSupplierNone: 'Tanlanmagan',
  toastRoleChanged: 'Rol o‘zgartirildi — audit jurnaliga yozildi',
  cancel: 'Bekor qilish',

  orders: 'Buyurtmalar',
  ordersSearch: 'Raqam, ism yoki telefon',
  ordersEmpty: 'Buyurtma topilmadi.',
  ordersFilterAll: 'Hammasi',
  ordersFilterPayment: "To'lov holati",

  order: 'Buyurtma',
  orderCustomer: 'Mijoz',
  orderDelivery: 'Yetkazish',
  orderItems: 'Tovarlar',
  orderPayments: "To'lovlar",
  orderShipments: "Jo'natmalar",
  orderHistory: 'Tarix',
  orderComment: 'Mijoz izohi',
  orderOperatorNote: 'Operator izohi',
  orderOperatorNoteHint:
    "Kelishilgan yetkazish sharti. Tizimda yetkazish narxi yo'q — telefonda kelishiladi.",
  orderNoteSave: 'Saqlash',
  orderNoteSaved: 'Saqlandi',
  orderNoteEmpty: 'Izoh yozilmagan',
  orderTotal: 'Jami',
  orderItemsTotal: 'Tovarlar summasi',
  orderDiscount: 'Chegirma',
  orderPaid: "To'langan",
  orderNoPayments: "To'lov yozuvi yo'q",
  orderSource: 'Manba',
  orderRegion: 'Hudud',
  orderAddress: 'Manzil',
  deliveryCourier: 'Yetkazib berish kerak',
  deliveryPickup: "Mijoz do'kondan olib ketadi",
  deliveryCourierShort: 'Yetkazish',
  deliveryPickupShort: 'Olib ketish',

  shipmentShop: "Do'kon",
  shipmentTracking: 'Trek raqami',
  shipmentEta: 'Muddat',
  shipmentEtaShifted: (n: number): string => `${String(n)} marta siljigan`,
  shipmentSelectShop: "Do'kon tanlang",
  shipmentAssignShop: 'Biriktirish',

  statusChange: 'Statusni o‘zgartirish',
  /* Kuryer oqimi */
  navDeliveries: 'Mening yetkazmalarim',
  courierAssignTitle: 'Kuryerga topshirish',
  courierCurrent: 'Kuryer',
  courierSelect: 'Kuryerni tanlang',
  courierEtaFrom: 'Yetkazish boshlanishi',
  courierEtaTo: 'Yetkazish tugashi (ixtiyoriy)',
  courierAssignButton: 'Kuryerga topshirish',
  courierChangeButton: 'Kuryerni almashtirish',
  courierNone: 'Bu do‘konda faol kuryer yo‘q. Xodimlar bo‘limida kuryer roli bering.',
  courierNeedShop: 'Avval jo‘natma uchun do‘kon tanlang.',
  courierHint:
    'Topshirilgach jo‘natma kuryerning ro‘yxatida paydo bo‘ladi. Taksi/BTS bilan yuborsangiz, quyidagi “Statusni o‘zgartirish” dan foydalaning.',
  toastCourierAssigned: 'Kuryerga topshirildi',
  deliveriesTitle: 'Mening yetkazmalarim',
  deliveriesActive: 'Yo‘lda',
  deliveriesDone: 'Natijalar',
  deliveriesEmptyActive:
    'Hozircha sizga yetkazma biriktirilmagan. Yangisi paydo bo‘lsa shu yerda chiqadi.',
  deliveriesEmptyDone: 'So‘nggi 7 kunda natija yo‘q.',
  deliveryOrder: 'Buyurtma',
  deliveryCustomer: 'Mijoz',
  deliveryAddress: 'Manzil',
  deliveryNote: 'Kelishuv',
  deliveryItems: 'Tovarlar',
  deliveryCashButton: 'Naqd pul oldim',
  deliveryCashAmount: 'Olingan summa (so‘m)',
  deliveryCashDue: (due: string): string => `Olinadigan summa: ${due}`,
  deliveryCashSave: 'Yozish',
  deliveryCashInvalid: 'Summani raqamda kiriting',
  deliveryCashNoteWait: 'Yozildi · kassir tasdiqlaguncha “kutilmoqda”',
  toastCashRecorded: 'Naqd pul yozildi — kassir tasdiqlaydi',
  deliveryPayment: 'To‘lov',
  deliveryPayPaid: 'To‘langan · pul olinmaydi',
  deliveryDelivered: 'Yetkazildi',
  deliveryFailed: 'Yetkazilmadi',
  deliveryConfirmDelivered: 'Ha, yetkazildi',
  deliveryReasonLabel: 'Sabab (majburiy)',
  deliveryReasonPlaceholder: 'Masalan: mijoz telefonni ko‘tarmadi',
  deliveryConfirmFailed: 'Yetkazilmadi deb belgilash',
  deliveryCancel: 'Bekor qilish',
  deliveryDoneAt: (date: string): string => `Yopildi: ${date}`,
  toastDelivered: 'Yetkazildi deb belgilandi',
  toastDeliveryFailed: 'Yetkazilmadi deb belgilandi',
  statusNoTransitions: 'Bu statusdan oldinga yo‘l yo‘q.',
  statusComment: 'Izoh',
  statusCommentRequired: 'Izoh majburiy',
  statusEtaFrom: 'Muddat boshlanishi',
  statusEtaTo: 'Muddat tugashi',
  statusEtaRequired: 'Muddat majburiy',
  statusApply: 'O‘zgartirish',
  statusApplying: 'Bajarilmoqda…',
  historyBy: 'Kim',
  historySystem: 'Tizim',
  historyEmpty: 'Tarix bo‘sh.',

  paymentRemaining: 'Qoldiq',
  paymentOverpaid: 'Ortiqcha olingan',
  paymentRecord: "To'lov yozish",
  paymentRecordSave: 'Yozish',
  paymentRecordHint:
    "Haqiqatda olingan pul yoziladi. Yozuv tasdiqlanmagan holatda tug'iladi va to'langan deb hisoblanmaydi.",
  paymentMethod: 'Usul',
  paymentAmount: 'Summa',
  paymentAmountHint: (formatted: string): string => `Yoziladi: ${formatted}`,
  paymentAmountInvalid: "Summa noto'g'ri. Faqat raqam, masalan 385 000",
  paymentCardLast4: 'Karta oxirgi 4 raqami',
  paymentConfirm: 'Tasdiqlash',
  paymentReject: 'Rad etish',
  paymentRefund: 'Qaytarish',
  paymentBankRef: "Bank ma'lumotnomasi",
  paymentBankRefHint:
    'Naqddan boshqa usulda majburiy. Chek rasmi dalil emas — uni oson soxtalashtirish mumkin.',
  paymentReason: 'Sabab',
  paymentVerifiedBy: 'Tasdiqladi',
  paymentAwaitingConfirmer: 'Tasdiqlashni kutmoqda',
  paymentOfTotal: "To'langan / jami",
  paymentReceipt: 'Chek',
  paymentHasReceipt: 'Chek bor',
  paymentQueueEmpty: "Tasdiqlanmagan to'lov yo'q.",
  paymentQueueEmptyHint: 'Operator pul olinganini yozsa, qator shu yerda chiqadi.',

  productNew: 'Yangi tovar',
  productEdit: 'Tovarni tahrirlash',
  productSave: 'Saqlash',
  productArchive: 'Arxivlash',
  productSearch: 'Artikul, nom yoki OEM raqami',
  productsEmpty: 'Tovar topilmadi.',
  productsEmptyHint: 'Qidiruv bazadan — qoralama tovarlar ham topiladi.',
  productSku: 'Artikul',
  productSkuHint: 'Tashqi tizimlar va import kaliti. Takrorlanmaydi.',
  productSkuLocked: "Artikul o'zgarmaydi — u import kaliti.",
  productSkuRequired: 'Artikul majburiy',
  productSlug: 'Slug',
  productSlugHint: 'URL manzili. Nomdan avtomatik quriladi, tahrirlash mumkin.',
  productSlugRequired: 'Slug majburiy',
  productName: 'Nomi',
  productNameUz: "Nomi (o'zbekcha)",
  productNameRu: 'Nomi (ruscha)',
  productNameRuHint: "Bo'sh bo'lsa o'zbekcha nom ko'rsatiladi.",
  productNameRequired: "O'zbekcha nom majburiy",
  productBrand: 'Brend',
  productCategory: 'Kategoriya',
  productPick: 'Tanlang',
  productRefRequired: 'Brend va kategoriya majburiy',
  productMain: "Asosiy ma'lumot",
  productPricing: 'Narx',
  productPrice: "Narx (so'm)",
  productPriceHint: "So'mda yoziladi, bazaga tiyinda tushadi.",
  productPriceRequired: "Narx majburiy va noldan katta bo'lishi kerak",
  productComingSoonShort: 'Tez kunda',
  productComingSoon: "Tez kunda (narx ko'rsatilmaydi)",
  productComingSoonHint:
    "Mijoz narx o'rniga «Tez kunda» ko'radi va tovarni savatga qo'sha olmaydi. Narxni keyin kiritasiz; belgini olishdan oldin narx bo'lishi shart.",
  productOldPrice: "Eski narx (so'm)",
  productOldPriceHint: "Chegirma ko'rsatish uchun. Joriy narxdan yuqori bo'lishi shart.",
  productOldPriceInvalid: "Eski narx noto'g'ri",
  productOldPriceTooLow: "Eski narx joriy narxdan yuqori bo'lishi kerak",
  productCost: "Tannarx (so'm)",
  productSupply: 'Yetkazish',
  stockTitle: "Do'konlardagi qoldiq",
  stockNotTracked:
    "Buyurtma asosidagi tovarda qoldiq yuritilmaydi: nechta so'ralsa shuncha buyurtma qilinadi.",
  stockSaveFirst: "Ta'minot turi o'zgargan. Qoldiqni kiritish uchun avval tovarni saqlang.",
  stockShop: "Do'kon",
  stockNow: 'Hozir',
  stockReserved: 'Bron',
  stockNew: 'Yangi qoldiq',
  stockNote: 'Izoh (jurnalga yoziladi)',
  stockNoteDefault: 'Admin: qoldiqni tuzatish',
  stockSave: 'Qoldiqni saqlash',
  stockSaved: 'Qoldiq saqlandi',
  stockNoChange: "Qoldiq o'zgarmagan",
  stockZeroHint: "Qoldiq 0 bo'lsa mijoz \"Hozircha tugagan\" ko'radi va savatga qo'sha olmaydi.",
  productSupplyType: "Ta'minot turi",
  productLeadTimeField: 'Kutish muddati (kun)',
  productLeadTimeRequired: "Buyurtma ostidagi tovarda kutish muddati noldan katta bo'lishi shart",
  productLeadTimeHint:
    "Buyurtma ostidagi tovar uchun majburiy. Mijoz ekranida shu muddat ko'rinadi.",
  productSizeClass: "O'lcham sinfi",
  productFindability: 'Topilish',
  productSearchTags: 'Qidiruv teglari',
  productSearchTagsHint:
    "BITTA maydon, tilga bo'linmaydi: model nomlari, xalq tilidagi atamalar, kirill variantlari.",
  productOemCodes: 'OEM va analog raqamlar',
  productOemHint: 'Vergul bilan ajratiladi. Ustalar aynan shu bo‘yicha qidiradi.',
  productDescription: 'Tavsif',
  productFitsUz: "Moslik (o'zbekcha)",
  productFitsRu: 'Moslik (ruscha)',
  productFitsHint: 'Bu kafolat emas — operator tasdiqlashda tekshiradi.',
  productDescUz: "Tavsif (o'zbekcha)",
  productDescRu: 'Tavsif (ruscha)',
  productStock: 'Qoldiq',
  productImage: 'Rasm',
  productLeadTime: (days: number): string => `${String(days)} kun`,
  productsDraftsHint: (count: number): string =>
    `${String(count)} ta qoralama tovar mijozga ko'rinmaydi.`,
  productsActivateAll: (count: number): string => `Hammasini faollashtirish (${String(count)})`,
  productsActivateConfirm: (count: number): string =>
    `${String(count)} ta tovar Faol bo'ladi va Mini App hamda saytda ko'rinadi. Davom etamizmi?`,
  productsActivateYes: 'Ha, faollashtirish',
  productsActivateNo: 'Bekor qilish',
  productsActivated: (activated: number, skipped: number, remaining: number): string =>
    [
      `${String(activated)} ta tovar faollashdi.`,
      skipped > 0
        ? `${String(skipped)} tasi qoralamada qoldi: narxi nol yoki buyurtma muddati yo'q.`
        : '',
      remaining > 0 ? `Yana ${String(remaining)} ta bor — qayta bosing.` : '',
    ]
      .filter((part) => part !== '')
      .join(' '),
  productMedia: 'Rasmlar',
  productMediaUpload: 'Rasm yuklash',
  productMediaRemoveBg: 'Fonni olib tashlash',
  productMediaRemoveBgHint:
    'Faqat oddiy surat uchun (tovar oq/tartibsiz fonda). Dizayn qilingan rasmda (fon, yozuv, logotip) o‘chiq qoldiring — rasm aynan yuklangandek chiqadi.',
  productMediaReprocess: 'Rasmlarni qayta ishlash',
  productMediaReprocessHint:
    'Qayta yuklamasdan, asl fayldan yangi qoida bilan qayta yasaydi (to‘liq ko‘rinadi, kvadrat). Yuqoridagi “Fonni olib tashlash” belgisi bu yerda ham amal qiladi.',
  productMediaReprocessed: (n: number): string =>
    `${String(n)} ta rasm qayta ishlashga qo‘yildi — bir necha soniyada yangilanadi`,
  productMediaHint:
    'JPEG yoki PNG, 12 MB gacha. Yuklashdan oldin kesish oynasi ochiladi. Bir nechta faylni birdan tanlash mumkin.',
  productMediaEmpty: "Rasm yo'q — mijozga kategoriya ikonkasi ko'rsatiladi.",
  productMediaPrimary: 'Asosiy',
  productMediaMakePrimary: 'Asosiy qilish',
  productMediaRemove: "O'chirish",
  cropTitle: 'Rasmni kesish',
  cropHint:
    "Rasmni suring, masshtabni o'zgartiring. Kartochkada rasm kvadrat ko'rinadi, uzun tovarni butun sig'dirish uchun masshtabni kichraytiring.",
  cropAspectGroup: 'Kesish nisbati',
  cropAspectSquare: 'Kvadrat',
  cropAspectLandscape: '4:3',
  cropAspectPortrait: '3:4',
  cropAspectBanner: 'Banner 1200×620',
  cropFrameLabel: 'Kesish maydoni. Strelkalar suradi, plyus va minus masshtabni o‘zgartiradi.',
  cropZoom: 'Masshtab',
  cropApply: 'Kesib yuklash',
  cropSkip: 'Kesmasdan yuklash',
  cropCancel: 'Bekor qilish',
  cropLoadFailed:
    "Bu rasmni ko'rsatib bo'lmadi (format qo'llab-quvvatlanmaydi). Uni kesmasdan yuklash mumkin.",
  cropExportFailed: "Kesib bo'lmadi. Qayta urining yoki kesmasdan yuklang.",

  importFile: 'Fayl',
  importUpload: 'Excel yoki CSV yuklash',
  importUploadHint:
    "`.xlsx` yoki `.csv`. Fayl avval TEKSHIRILADI — natijani ko'rib turib qo'llaysiz.",
  importColumnsShow: "Qanday ustunlar tanilishini ko'rsatish",
  importColumnsHide: 'Yopish',
  importColumnsHint:
    "Sarlavha shu nomlardan biri bo'lsa yetarli. Katta-kichik harf va probel ahamiyatsiz. `sku` — YAGONA majburiy ustun.",
  importStockHelp:
    "Qoldiq: har do'kon uchun alohida ustun — masalan `Qoldiq Toshkent`, `Qoldiq Urganch` (do'kon nomi yoki kodi). Katakka BUTUN son yozing; bo'sh katak tegilmaydi. Buyurtma ostida keladigan tovar uchun `supplyType` = PRE_ORDER va `leadTimeDays` yozing — qoldiq KERAK EMAS, nechta so'ralsa shuncha buyurtma qilinadi. `supplyType` yozilmasa tovar IN_STOCK bo'ladi: qoldiqsiz u \"Hozircha tugagan\" chiqadi.",
  importStockShops: "Qoldiq ustunlari (do'kon)",
  importTotal: 'Jami qator',
  importWillCreate: 'Yaratiladi',
  importWillUpdate: 'Yangilanadi',
  importErrors: 'Xatolar',
  importRow: 'Qator',
  importColumn: 'Ustun',
  importValue: 'Qiymat',
  importAction: 'Amal',
  importRecognized: 'Tanilgan ustunlar',
  importIgnored: 'Tanilmagan sarlavhalar',
  importPreview: "Ko'rib chiqish",
  importApply: "Qo'llash",
  importApplied: "Qo'llandi.",
  importSkipHint: (n: number): string => `${String(n)} ta xatoli qator tashlab yuboriladi`,

  refSettings: 'Sozlamalar',
  refCategories: 'Kategoriyalar',
  refBrands: 'Brendlar',
  refPublic: 'Ochiq',
  refYes: 'Ha',
  refNo: "Yo'q",
  refActive: 'Faol',
  refInactive: 'Yashirilgan',
  refHide: 'Yashirish',
  refShow: "Ko'rsatish",
  refDelete: "O'chirish",
  refAdd: "Qo'shish",
  refAddCategory: 'Yangi kategoriya',
  refAddBrand: 'Yangi brend',
  refNameUz: "Nomi (o'zbekcha)",
  refBrandName: 'Brend nomi',
  refCountry: 'Mamlakat',
  refNoParent: 'Ildiz kategoriya',
  refSlugPreview: 'Slug',
  refProductCount: (n: number): string => `${String(n)} ta tovar`,
  refInvalidType: (type: string): string => `Qiymat turi mos emas: ${type} kutilmoqda`,

  refVehicles: 'Avtomobillar',
  refSynonyms: 'Sinonimlar',
  refBanners: 'Bannerlar',
  refMakeName: 'Marka nomi',
  refAddMake: "Marka qo'shish",
  refModels: 'Modellar',
  refAllMakes: 'Barcha markalar',
  refAddModel: 'Yangi model',
  refModelName: 'Model nomi',
  refYearFrom: 'Yildan',
  refYearTo: 'Yilgacha',
  refAliases: 'Qidiruv yozilishlari',
  refAliasesHint: 'Vergul bilan: treker, трекер, tacker. Bu maydon qidiruv indeksiga tushadi.',
  refPickMake: 'Avval markani tanlang',
  refYearsInvalid: "Yil oralig'i noto'g'ri",
  refAddSynonym: 'Yangi sinonim',
  refTerm: 'Atama',
  refSynonymValues: 'Sinonimlar (vergul bilan)',
  refSynonymsHint:
    "Har o'zgarish qidiruv indeksiga darhol ko'chiriladi. Natijasiz so'rovlar jurnaliga qarab to'ldiriladi.",
  refAddBanner: 'Yangi banner',
  refEditBanner: 'Bannerni tahrirlash',
  refSaveBanner: 'O‘zgarishlarni saqlash',
  refBannerTitle: 'Sarlavha',
  refBannerSubtitle: 'Tavsif',
  refBannerBadge: 'Yorliq',
  refBannerTitleUz: "Sarlavha (o'zbekcha)",
  refBannerTitleRu: 'Sarlavha (ruscha, ixtiyoriy)',
  refBannerSubtitleUz: "Tavsif (o'zbekcha)",
  refBannerSubtitleRu: 'Tavsif (ruscha, ixtiyoriy)',
  refBannerBadgeUz: "Yorliq (o'zbekcha)",
  refBannerBadgeRu: 'Yorliq (ruscha, ixtiyoriy)',
  refBannerStartsAt: 'Boshlanish vaqti (ixtiyoriy)',
  refBannerEndsAt: 'Tugash vaqti (ixtiyoriy)',
  refBannerSort: 'Ko‘rinish tartibi (0–9999, ixtiyoriy)',
  refBannerDateInvalid: 'Boshlanish vaqti tugash vaqtidan oldin bo‘lishi kerak.',
  refBannerSortInvalid: 'Tartib 0 dan 9999 gacha butun son bo‘lishi kerak.',
  refBannerLink: 'Bosilganda qayerga olib boradi',
  refBannerLinkNone: 'Hech qayerga (faqat reklama)',
  refBannerLinkProduct: 'Tovar sahifasiga',
  refBannerLinkCategory: 'Kategoriyaga',
  refBannerLinkCatalog: 'Butun katalogga',
  refBannerLinkSearch: 'Qidiruv natijasiga',
  refBannerLinkChosen: 'Tanlangan tovar',
  refBannerFillFromProduct: 'Banner matnini tovardan to‘ldirish',
  refBannerLinkProductSearch: 'Tovarni artikul, nom yoki OEM raqami bilan qidiring',
  refBannerLinkNoProducts: 'Faol tovar topilmadi.',
  refBannerLinkPickCategory: 'Kategoriyani tanlang',
  refBannerLinkSearchPlaceholder: 'Masalan: amortizator',
  refBannerLinkIncomplete: 'Havola uchun nishonni tanlang yoki "Hech qayerga" ni qoldiring.',
  refCategoryImage: 'Kategoriya rasmi',
  refCategoryImageUpload: 'Rasm yuklash',
  refCategoryImageReplace: 'Rasmni almashtirish',
  refCategoryImageRemove: 'Rasmni olib tashlash',
  refCategoryImageHint:
    'Kvadrat, kamida 96×96 px (tavsiya 256×256), shaffof PNG/WebP yaxshi. Rasm yo‘q bo‘lsa — ikonka chiqadi.',
  refCategoryImageDone: 'Kategoriya rasmi saqlandi',
  refCategoryImageRemoved: 'Kategoriya rasmi olib tashlandi',
  refBannerImage: 'Banner rasmi',
  refBannerImageUpload: 'Rasm yuklash',
  refBannerImageReplace: 'Rasmni almashtirish',
  refBannerImageRemove: 'Rasmni olib tashlash',
  refBannerImageHint:
    'Tavsiya: 1200×620 px (kamida 600×300), JPG/PNG/WebP, 12 MB gacha. Mahsulotni rasmning o‘ng yarmiga joylang: chap tomonda sarlavha va narx turadi.',
  refBannerImageType: 'Faqat JPG, PNG, WebP yoki AVIF rasm yuklash mumkin.',
  refBannerImageTooBig: 'Fayl juda katta (12 MB dan oshmasin).',
  refBannerImageEmpty: 'JPG, PNG yoki WebP faylni tanlang. Keyingi qadamda uni kesib olasiz.',
  refBannerImagePending: 'Yangi rasm — «Saqlash» bosilganda yuklanadi.',
  refBannerImageFailedAfterSave:
    'Banner saqlandi, lekin rasm yuklanmadi. Bannerni oching va rasmni qayta tanlang.',
  refBannerColor: 'Rang va ikonka (rasm bo‘lmaganda)',
  refBannerColorNone: 'Standart',
  refBannerColorEngine: 'Dvigatel',
  refBannerColorBrakes: 'Tormoz',
  refBannerColorOils: 'Moylar',
  refBannerColorElectric: 'Elektr',
  refBannerColorTires: 'Shinalar',
  refBannerColorAccess: 'Aksessuarlar',
  refBannersLead:
    'Bosh sahifadagi katta reklama kartochkalari. Ro‘yxatdagi tartib bilan ko‘rinadi: yuqoridagisi birinchi.',
  refBannersCacheNote:
    'O‘zgarish mijozlarga 1–5 daqiqada ko‘rinadi: ilova ma’lumotni qisqa vaqt eslab turadi.',
  refBannersEmpty: 'Hali banner yo‘q',
  refBannersEmptyHint:
    'Banner — bosh sahifadagi katta reklama kartochkasi: rasm, sarlavha va bosilganda tovar yoki kategoriyaga o‘tish. Birinchisini qo‘shing.',
  refBannerStateLive: 'Mijozga ko‘rinmoqda',
  refBannerStateHidden: 'Yashirilgan',
  refBannerStateScheduled: 'Hali boshlanmagan',
  refBannerStateExpired: 'Muddati tugagan',
  refBannerEditShort: 'Tahrirlash',
  refBannerNoImage: 'Rasmsiz',
  refBannerNoLink: 'Havolasiz',
  refBannerFrom: 'dan',
  refBannerDeleteTitle: 'Bannerni o‘chirish?',
  refBannerDeleteBody:
    'Banner butunlay o‘chadi va qaytarib bo‘lmaydi. Vaqtincha olib qo‘ymoqchi bo‘lsangiz — «Yashirish» ni bosing: keyin yana ko‘rsatish mumkin.',
  refBannerEditorClose: 'Yopish',
  refBannerPreview: 'Mijoz ilovasida shunday ko‘rinadi',
  refBannerPreviewTitle: 'Banner sarlavhasi',
  refBannerStep1: 'Rasm',
  refBannerStep1Hint: 'Banner foni. Rasm ixtiyoriy: rasmsiz banner rangli ko‘rinadi.',
  refBannerStep2: 'Matn',
  refBannerStep2Hint:
    'Sarlavha — qisqa va aniq (3–6 so‘z). Ruscha matn bo‘sh qolsa, ruscha foydalanuvchiga o‘zbekcha ko‘rinadi.',
  refBannerStep3: 'Bosilganda nima bo‘ladi',
  refBannerStep3Hint:
    'Tovar, kategoriya yoki qidiruvga o‘tkazish. Kerak bo‘lmasa — «Hech qayerga».',
  refBannerStep4: 'Qachon va qaysi tartibda ko‘rinadi',
  refBannerStep4Hint:
    'Sana qo‘yilmasa banner doim ko‘rinadi. Tartib: kichik raqam — oldinroq (bo‘sh qoldirsangiz oxiriga tushadi).',
  refBannerNeedTitle: 'Sarlavhani (o‘zbekcha) kiriting.',
  refBannerDiscardTitle: 'O‘zgarishlar saqlanmagan. Chiqasizmi?',
  refBannerDiscard: 'Chiqish',
  refBannerKeepEditing: 'Davom etish',
  refUntil: 'gacha',

  refShops: "Do'konlar",
  refZones: 'Yetkazish zonalari',
  refStatuses: 'Statuslar',
  refAddShop: "Yangi do'kon",
  refShopCode: 'Kod',
  refShopCodeHint:
    "Kod FAQAT katta harf, raqam va pastki chiziq: TASHKENT_SERGELI. U o'zgarmaydi va tashqi tizimlarda ishlatiladi.",
  refPickRegion: 'Hududni tanlang',
  refAddress: 'Manzil',
  refAddZone: 'Yangi zona',
  refZoneService: 'Xizmat (masalan: Oʻz kuryerimiz)',
  refZoneEta: 'Muddat (masalan: 1-2 kun)',
  refZonesHint:
    "Zonada NARX YO'Q — yetkazish sharti operator bilan telefonda kelishiladi. Bu yerda faqat xizmat nomi va taxminiy muddat.",
  refNoRegions: 'Hudud biriktirilmagan',
  refFallback: 'Zaxira',
  refStatusesHint:
    "Yorliq va push sozlanadi. Status kodi, oqim va o'tishlar grafi TAHRIRLANMAYDI — graf buyurtma oqimining o'zi.",
  refTerminal: 'yakuniy',
  refNotifyOn: 'Push yoqilgan',
  refNotifyOff: "Push o'chiq",
  refNotifyDisable: "Pushni o'chirish",
  refNotifyEnable: 'Pushni yoqish',

  analyticsDays: (n: number): string => `${String(n)} kun`,
  analyticsTotals: 'Umumiy',
  analyticsRevenue: 'Tushum',
  analyticsRegions: 'Hududlar',
  analyticsRegionsHint: "Buyurtma ko'p, lekin do'kon yo'q — yangi nuqta ochish uchun asos.",
  analyticsHasShop: "Do'kon bor",
  analyticsNoShop: "Do'kon yo'q",
  analyticsEmptySearches: 'Natijasiz qidiruvlar',
  analyticsEmptySearchesHint:
    "Mijozlar sotib olmoqchi bo'lgan, lekin topa olmagan tovarlar. Assortiment rejasi shundan chiqadi.",
  analyticsGarage: 'Garajdagi mashinalar',
  analyticsGarageHint: 'Qaysi model uchun tovar kerakligini shu ko‘rsatadi.',
  analyticsQuery: 'So‘rov',
  analyticsCount: 'Soni',
  analyticsLastAt: 'Oxirgi marta',
  analyticsEmpty: 'Bu davrda ma‘lumot yo‘q.',

  auditHint:
    "Kim nima qildi. Yozuv o'chirilmaydi va tahrirlanmaydi — o'zgartirilishi mumkin bo'lgan jurnal dalil bo'la olmaydi.",
  auditAt: 'Vaqt',
  auditAction: 'Amal',
  auditEntityCol: 'Obyekt',
  auditChanges: "Nima o'zgardi",
  auditEmpty: 'Yozuv yo‘q.',

  usersCreate: 'Xodim yaratish',
  usersCreateHint:
    "Xodim o'zi ro'yxatdan o'tmaydi — uni Owner yaratadi. Rol berish va olib qo'yish audit jurnaliga tushadi.",
  usersPasswordHint: 'Kamida 12 belgi, katta va kichik harf hamda raqam.',
  usersLoginInvalid: 'Login 3–64 belgi: faqat kichik lotin harfi, raqam va _.',
  usersLoginTaken: 'Bu login band. Boshqa login kiriting.',
  usersNameInvalid: 'Ismni kiriting (ko‘pi bilan 80 belgi).',
  usersPasswordInvalid: 'Parol 12–128 belgi, katta va kichik harf hamda raqamdan iborat bo‘lsin.',
  usersRoleRequired: 'Bitta rol tanlang.',
  usersShopRequired: 'Ushbu rol uchun do‘kon tanlang.',
  usersLogin: 'Login',
  usersName: 'Ism',
  usersState: 'Holat',
  usersActive: 'Faol',
  usersInactive: 'Faol emas',
  usersRoles: 'Rollar',
  usersNoRole: 'Rol yo‘q',
  usersAddRole: 'Rol qo‘shish',
  usersShop: 'Do‘kon',
  usersShopHint: 'Kuryer faqat shu do‘kon jo‘natmalari bilan ishlaydi.',
  usersRoleUnclassified: 'tasniflanmagan',
  usersSearch: 'Login yoki ism',
  usersEmpty: 'Xodim topilmadi.',

  dashboardSubtitle: (role: string): string => `${role} sifatida`,
  dashboardRevenue: 'Aylanma',
  dashboardRevenueHint: 'jami',
  dashboardProfit: 'Yalpi foyda',
  dashboardProfitHint: "Faqat Owner ko'radi",
  dashboardClosed: 'Yopiq',
  dashboardMargin: (percent: number): string => `marja ${String(percent)}%`,
  dashboardNewOrders: (n: number): string => `${String(n)} tasi yangi`,
  dashboardActiveProducts: 'Faol tovarlar',
  dashboardDrafts: (n: number): string => `${String(n)} ta qoralama`,
  dashboardAttention: "E'tibor talab qiladi",
  dashboardAllClear: 'Hozircha hammasi joyida.',
  dashboardTop: "Ko'p sotilgan",
  dashboardNoSales: 'Hali sotuv yo‘q.',
  dashboardAlert: (kind: string, n: number): string =>
    ({
      NEW_ORDERS: `${String(n)} ta yangi buyurtma tasdiqlanmagan`,
      PENDING_PAYMENTS: `${String(n)} ta to'lov tasdiqlanmagan`,
      EMPTY_SEARCHES: `${String(n)} ta so'rov natijasiz qoldi`,
      OUT_OF_STOCK: `${String(n)} ta faol tovar hech qayerda yo'q ("Hozircha tugagan")`,
    })[kind] ?? String(n),
  consignmentsCount: (n: number): string => `${String(n)} ta`,
  consignmentsHint:
    "Partiya — bitta mashina, bitta invoys. Status o'zgartirilganda ichidagi BARCHA jo'natma birga ko'chadi.",
  consignmentsEmpty: 'Partiya yo‘q.',
  consignmentsEmptyHint:
    "Xitoydan yuk kelganda partiya ochiladi va jo'natmalar unga biriktiriladi.",
  consignmentInvoice: 'Invoys',
  consignmentSupplier: "Ta'minotchi",
  consignmentShipments: "Jo'natma",
  consignmentMove: "Ko'chirish",
  consignmentEnd: 'Oxirgi bosqich',
  consignmentResult: 'Natija',
  consignmentMoved: (moved: number, notified: number): string =>
    `${String(moved)} ta jo'natma ko'chdi, ${String(notified)} ta mijozga xabar ketdi.`,
  consignmentSkipped: (n: number): string => `${String(n)} ta jo'natma ko'chmadi:`,
  consignmentSkipReason: (reason: string): string =>
    reason === 'FORBIDDEN' ? 'ruxsat yetmadi' : "bu statusdan bunday o'tish yo'q",
  dashboardAlertHint: (kind: string): string =>
    ({
      NEW_ORDERS: "Operator qo'ng'iroq qilishi kerak",
      PENDING_PAYMENTS: 'Pul olinganini kimdir tasdiqlashi kerak',
      EMPTY_SEARCHES: "Assortiment yoki teglarni to'ldirish kerak",
      OUT_OF_STOCK: "Qoldiq kiriting yoki buyurtma asosiga (PRE_ORDER) o'tkazing",
    })[kind] ?? '',
  auditEntity: (entity: string): string =>
    ({
      Product: 'Tovar',
      Payment: "To'lov",
      Shipment: "Jo'natma",
      User: 'Foydalanuvchi',
      Order: 'Buyurtma',
      Setting: 'Sozlama',
    })[entity] ?? entity,
};

/**
 * Matnlar shakli UZ dan olinadi va RU unga MAJBURLANADI. Shuning uchun
 * ruscha tarjimada kalit unutilsa `tsc` yiqiladi — bo'sh joy chiqmaydi.
 */
export type Messages = typeof UZ;

const RU: Messages = {
  appTitle: 'AvtoPartShop',
  appSubtitle: 'Панель управления',

  loginTitle: 'Вход',
  loginHint: 'Логин и пароль выдаёт владелец. Открытой регистрации нет.',
  loginField: 'Логин',
  passwordField: 'Пароль',
  totpField: 'Одноразовый код',
  totpHint: 'Для владельца — 6 цифр из приложения-аутентификатора',
  signIn: 'Войти',
  signingIn: 'Вход…',
  signOut: 'Выйти',

  workQueue: 'Очередь задач',
  workQueueEmpty: 'Очередь пуста. Задач пока нет.',
  bucketEmpty: 'В этой группе задач нет.',
  back: 'Назад',
  refresh: 'Обновить',
  loadMore: 'Загрузить ещё',
  loading: 'Загрузка…',

  colOrder: 'Заказ',
  colCustomer: 'Клиент',
  colShop: 'Магазин',
  colStatus: 'Статус',
  colTotal: 'Сумма',
  colWaiting: 'Ожидает',
  colEta: 'Срок',

  shopUnset: 'Не выбран',
  etaUnset: 'Не назначен',
  overdue: 'Просрочено',
  itemsCount: (n: number): string => `${String(n)} позиций`,
  waitingDays: (n: number): string => `${String(n)} дн.`,
  waitingHours: (n: number): string => `${String(n)} ч.`,
  waitingMinutes: (n: number): string => `${String(n)} мин.`,
  oldest: 'Самая старая',

  errorTitle: 'Ошибка',
  retry: 'Повторить',
  navQueue: 'Очередь задач',
  navOrders: 'Заказы',
  navPayments: 'Оплаты',
  navProducts: 'Товары',
  navImport: 'Импорт',
  navReference: 'Справочники',
  navDashboard: 'Панель управления',
  navConsignments: 'Партии из Китая',
  navAudit: 'Журнал аудита',
  navUsers: 'Сотрудники',
  navProductNew: 'Добавить товар',
  navCategories: 'Категории и бренды',
  navSearchLog: 'Журнал поиска',
  navGarage: 'Статистика гаражей',
  navRegions: 'По регионам',
  navGroupGeneral: 'Общее',
  navGroupCatalog: 'Каталог',
  navGroupAnalytics: 'Аналитика',
  navGroupShops: 'Магазины',
  navGroupSystem: 'Система',
  navLabel: 'Главное меню',
  toastStatusPush: 'Статус обновлён · клиенту ушёл push',
  toastStatusNoPush: 'Статус обновлён · push не отправляется, сообщите клиенту сами',
  toastSaved: 'Сохранено',
  toastAdded: 'Добавлено',
  toastDeleted: 'Удалено',
  toastSettingSaved: 'Настройка сохранена',
  toastNoteSaved: 'Заметка сохранена',
  toastFailed: 'Не выполнено',
  toastPaymentConfirmed: 'Оплата подтверждена',
  toastProductSaved: 'Товар сохранён',
  toastProductArchived: 'Товар перенесён в архив',
  toastProductCreated: 'Товар создан. Теперь можно добавить фото.',
  toastShopAssigned: 'Магазин назначен',
  consignmentShipmentCount: (n: number): string => `${String(n)} отправлений`,
  consignmentNoShipments: 'В этой партии нет отправлений',
  consignmentNew: 'Новая партия',
  consignmentCreate: 'Открыть',
  consignmentCreated: 'Партия открыта',
  consignmentSupplierNone: 'Не выбран',
  toastRoleChanged: 'Роль изменена — записано в журнал аудита',
  cancel: 'Отмена',

  orders: 'Заказы',
  ordersSearch: 'Номер, имя или телефон',
  ordersEmpty: 'Заказы не найдены.',
  ordersFilterAll: 'Все',
  ordersFilterPayment: 'Статус оплаты',

  order: 'Заказ',
  orderCustomer: 'Клиент',
  orderDelivery: 'Доставка',
  orderItems: 'Товары',
  orderPayments: 'Оплаты',
  orderShipments: 'Отправления',
  orderHistory: 'История',
  orderComment: 'Комментарий клиента',
  orderOperatorNote: 'Заметка оператора',
  orderOperatorNoteHint:
    'Согласованные условия доставки. Цены доставки в системе нет — договариваются по телефону.',
  orderNoteSave: 'Сохранить',
  orderNoteSaved: 'Сохранено',
  orderNoteEmpty: 'Заметки нет',
  orderTotal: 'Итого',
  orderItemsTotal: 'Сумма товаров',
  orderDiscount: 'Скидка',
  orderPaid: 'Оплачено',
  orderNoPayments: 'Записей об оплате нет',
  orderSource: 'Источник',
  orderRegion: 'Регион',
  orderAddress: 'Адрес',
  deliveryCourier: 'Нужна доставка',
  deliveryPickup: 'Клиент заберёт в магазине',
  deliveryCourierShort: 'Доставка',
  deliveryPickupShort: 'Самовывоз',

  shipmentShop: 'Магазин',
  shipmentTracking: 'Трек-номер',
  shipmentEta: 'Срок',
  shipmentEtaShifted: (n: number): string => `сдвигался ${String(n)} раз`,
  shipmentSelectShop: 'Выберите магазин',
  shipmentAssignShop: 'Привязать',

  statusChange: 'Изменить статус',
  /* Курьер */
  navDeliveries: 'Мои доставки',
  courierAssignTitle: 'Передать курьеру',
  courierCurrent: 'Курьер',
  courierSelect: 'Выберите курьера',
  courierEtaFrom: 'Начало доставки',
  courierEtaTo: 'Конец доставки (необязательно)',
  courierAssignButton: 'Передать курьеру',
  courierChangeButton: 'Сменить курьера',
  courierNone:
    'В этом магазине нет активных курьеров. Назначьте роль курьера в разделе сотрудников.',
  courierNeedShop: 'Сначала выберите магазин для отправления.',
  courierHint:
    'После передачи отправление появится в списке курьера. Если отправляете такси/BTS, используйте «Изменить статус» ниже.',
  toastCourierAssigned: 'Передано курьеру',
  deliveriesTitle: 'Мои доставки',
  deliveriesActive: 'В пути',
  deliveriesDone: 'Результаты',
  deliveriesEmptyActive: 'Пока вам не назначены доставки. Новые появятся здесь.',
  deliveriesEmptyDone: 'За последние 7 дней результатов нет.',
  deliveryOrder: 'Заказ',
  deliveryCustomer: 'Клиент',
  deliveryAddress: 'Адрес',
  deliveryNote: 'Договорённость',
  deliveryItems: 'Товары',
  deliveryCashButton: 'Получил наличные',
  deliveryCashAmount: 'Полученная сумма (сум)',
  deliveryCashDue: (due: string): string => `К получению: ${due}`,
  deliveryCashSave: 'Записать',
  deliveryCashInvalid: 'Введите сумму цифрами',
  deliveryCashNoteWait: 'Записано · до подтверждения кассиром «ожидает»',
  toastCashRecorded: 'Наличные записаны — подтвердит кассир',
  deliveryPayment: 'Оплата',
  deliveryPayPaid: 'Оплачен · деньги не брать',
  deliveryDelivered: 'Доставлено',
  deliveryFailed: 'Не доставлено',
  deliveryConfirmDelivered: 'Да, доставлено',
  deliveryReasonLabel: 'Причина (обязательно)',
  deliveryReasonPlaceholder: 'Например: клиент не отвечает на звонок',
  deliveryConfirmFailed: 'Отметить как не доставлено',
  deliveryCancel: 'Отмена',
  deliveryDoneAt: (date: string): string => `Закрыто: ${date}`,
  toastDelivered: 'Отмечено как доставлено',
  toastDeliveryFailed: 'Отмечено как не доставлено',
  statusNoTransitions: 'Из этого статуса нет пути вперёд.',
  statusComment: 'Комментарий',
  statusCommentRequired: 'Комментарий обязателен',
  statusEtaFrom: 'Начало срока',
  statusEtaTo: 'Конец срока',
  statusEtaRequired: 'Срок обязателен',
  statusApply: 'Изменить',
  statusApplying: 'Выполняется…',
  historyBy: 'Кто',
  historySystem: 'Система',
  historyEmpty: 'История пуста.',

  paymentRemaining: 'Остаток',
  paymentOverpaid: 'Переплата',
  paymentRecord: 'Записать оплату',
  paymentRecordSave: 'Записать',
  paymentRecordHint:
    'Записывается фактически полученная сумма. Запись создаётся неподтверждённой и не считается оплатой.',
  paymentMethod: 'Способ',
  paymentAmount: 'Сумма',
  paymentAmountHint: (formatted: string): string => `Будет записано: ${formatted}`,
  paymentAmountInvalid: 'Неверная сумма. Только цифры, например 385 000',
  paymentCardLast4: 'Последние 4 цифры карты',
  paymentConfirm: 'Подтвердить',
  paymentReject: 'Отклонить',
  paymentRefund: 'Вернуть',
  paymentBankRef: 'Банковский референс',
  paymentBankRefHint:
    'Обязателен для всех способов, кроме наличных. Скриншот чека не доказательство — его легко подделать.',
  paymentReason: 'Причина',
  paymentVerifiedBy: 'Подтвердил',
  paymentAwaitingConfirmer: 'Ожидает подтверждения',
  paymentOfTotal: 'Оплачено / итого',
  paymentReceipt: 'Чек',
  paymentHasReceipt: 'Чек есть',
  paymentQueueEmpty: 'Неподтверждённых платежей нет.',
  paymentQueueEmptyHint: 'Как только оператор запишет полученные деньги, строка появится здесь.',

  productNew: 'Новый товар',
  productEdit: 'Редактирование товара',
  productSave: 'Сохранить',
  productArchive: 'В архив',
  productSearch: 'Артикул, название или OEM-номер',
  productsEmpty: 'Товары не найдены.',
  productsEmptyHint: 'Поиск идёт по базе — черновики тоже находятся.',
  productSku: 'Артикул',
  productSkuHint: 'Ключ для внешних систем и импорта. Не повторяется.',
  productSkuLocked: 'Артикул не меняется — это ключ импорта.',
  productSkuRequired: 'Артикул обязателен',
  productSlug: 'Slug',
  productSlugHint: 'Адрес в URL. Строится из названия, можно изменить.',
  productSlugRequired: 'Slug обязателен',
  productName: 'Название',
  productNameUz: 'Название (узбекский)',
  productNameRu: 'Название (русский)',
  productNameRuHint: 'Если пусто — показывается узбекское название.',
  productNameRequired: 'Узбекское название обязательно',
  productBrand: 'Бренд',
  productCategory: 'Категория',
  productPick: 'Выберите',
  productRefRequired: 'Бренд и категория обязательны',
  productMain: 'Основное',
  productPricing: 'Цена',
  productPrice: 'Цена (сум)',
  productPriceHint: 'Вводится в сумах, в базу попадает в тийинах.',
  productPriceRequired: 'Цена обязательна и должна быть больше нуля',
  productComingSoonShort: 'Скоро',
  productComingSoon: 'Скоро в продаже (цена не показывается)',
  productComingSoonHint:
    'Вместо цены клиент увидит «Скоро» и не сможет добавить товар в корзину. Цену укажете позже; перед снятием отметки цена обязательна.',
  productOldPrice: 'Старая цена (сум)',
  productOldPriceHint: 'Для показа скидки. Должна быть выше текущей цены.',
  productOldPriceInvalid: 'Неверная старая цена',
  productOldPriceTooLow: 'Старая цена должна быть выше текущей',
  productCost: 'Себестоимость (сум)',
  productSupply: 'Поставка',
  stockTitle: 'Остаток по магазинам',
  stockNotTracked: 'У товара под заказ остаток не ведётся: можно заказать любое количество.',
  stockSaveFirst: 'Тип поставки изменён. Чтобы ввести остаток, сначала сохраните товар.',
  stockShop: 'Магазин',
  stockNow: 'Сейчас',
  stockReserved: 'Бронь',
  stockNew: 'Новый остаток',
  stockNote: 'Комментарий (попадёт в журнал)',
  stockNoteDefault: 'Админ: корректировка остатка',
  stockSave: 'Сохранить остаток',
  stockSaved: 'Остаток сохранён',
  stockNoChange: 'Остаток не изменился',
  stockZeroHint:
    'При остатке 0 клиент увидит «Временно нет в наличии» и не сможет добавить в корзину.',
  productSupplyType: 'Тип поставки',
  productLeadTimeField: 'Срок ожидания (дней)',
  productLeadTimeRequired: 'Для товара под заказ срок ожидания должен быть больше нуля',
  productLeadTimeHint: 'Обязателен для товара под заказ. Этот срок видит клиент.',
  productSizeClass: 'Класс размера',
  productFindability: 'Находимость',
  productSearchTags: 'Поисковые теги',
  productSearchTagsHint:
    'ОДНО поле, без деления на языки: названия моделей, народные термины, варианты кириллицей.',
  productOemCodes: 'OEM и аналоги',
  productOemHint: 'Через запятую. Мастера ищут именно по ним.',
  productDescription: 'Описание',
  productFitsUz: 'Совместимость (узбекский)',
  productFitsRu: 'Совместимость (русский)',
  productFitsHint: 'Это не гарантия — оператор проверяет при подтверждении.',
  productDescUz: 'Описание (узбекский)',
  productDescRu: 'Описание (русский)',
  productStock: 'Остаток',
  productImage: 'Фото',
  productLeadTime: (days: number): string => `${String(days)} дн.`,
  productsDraftsHint: (count: number): string => `${String(count)} черновиков не видны клиентам.`,
  productsActivateAll: (count: number): string => `Активировать все (${String(count)})`,
  productsActivateConfirm: (count: number): string =>
    `${String(count)} товаров станут активными и появятся в Mini App и на сайте. Продолжить?`,
  productsActivateYes: 'Да, активировать',
  productsActivateNo: 'Отмена',
  productsActivated: (activated: number, skipped: number, remaining: number): string =>
    [
      `Активировано товаров: ${String(activated)}.`,
      skipped > 0
        ? `Остались черновиками: ${String(skipped)} (нулевая цена или нет срока под заказ).`
        : '',
      remaining > 0 ? `Ещё ${String(remaining)} — нажмите снова.` : '',
    ]
      .filter((part) => part !== '')
      .join(' '),
  productMedia: 'Фотографии',
  productMediaUpload: 'Загрузить фото',
  productMediaRemoveBg: 'Удалить фон',
  productMediaRemoveBgHint:
    'Только для обычного фото (товар на белом/случайном фоне). Для готового дизайна (фон, надписи, логотип) оставьте выключенным — фото останется как загружено.',
  productMediaReprocess: 'Переобработать фото',
  productMediaReprocessHint:
    'Пересоздаёт фото из оригинала по новым правилам без повторной загрузки (целиком, квадрат). Галочка «Удалить фон» выше действует и здесь.',
  productMediaReprocessed: (n: number): string =>
    `Поставлено в обработку фото: ${String(n)} — обновятся через несколько секунд`,
  productMediaHint:
    'JPEG или PNG, до 12 МБ. Перед загрузкой откроется окно обрезки. Можно выбрать несколько файлов сразу.',
  productMediaEmpty: 'Фото нет — клиенту показывается иконка категории.',
  productMediaPrimary: 'Основное',
  productMediaMakePrimary: 'Сделать основным',
  productMediaRemove: 'Удалить',
  cropTitle: 'Обрезка фото',
  cropHint:
    'Перетащите фото и измените масштаб. В карточке фото квадратное; чтобы длинный товар поместился целиком, уменьшите масштаб.',
  cropAspectGroup: 'Соотношение сторон',
  cropAspectSquare: 'Квадрат',
  cropAspectLandscape: '4:3',
  cropAspectPortrait: '3:4',
  cropAspectBanner: 'Баннер 1200×620',
  cropFrameLabel: 'Область обрезки. Стрелки двигают фото, плюс и минус меняют масштаб.',
  cropZoom: 'Масштаб',
  cropApply: 'Обрезать и загрузить',
  cropSkip: 'Загрузить без обрезки',
  cropCancel: 'Отмена',
  cropLoadFailed:
    'Это фото не удалось показать (формат не поддерживается). Его можно загрузить без обрезки.',
  cropExportFailed: 'Не удалось обрезать. Повторите или загрузите без обрезки.',

  importFile: 'Файл',
  importUpload: 'Загрузить Excel или CSV',
  importUploadHint: '`.xlsx` или `.csv`. Файл сначала ПРОВЕРЯЕТСЯ — вы применяете, видя результат.',
  importColumnsShow: 'Показать распознаваемые столбцы',
  importColumnsHide: 'Свернуть',
  importColumnsHint:
    'Достаточно одного из этих названий в заголовке. Регистр и пробелы не важны. `sku` — ЕДИНСТВЕННЫЙ обязательный столбец.',
  importStockHelp:
    'Остаток: отдельный столбец для каждого магазина — например `Остаток Ташкент`, `Остаток Урганч` (название или код магазина). В ячейке — ЦЕЛОЕ число; пустая ячейка не меняется. Для товара под заказ укажите `supplyType` = PRE_ORDER и `leadTimeDays` — остаток НЕ нужен, заказывать можно любое количество. Без `supplyType` товар будет IN_STOCK: без остатка он покажется как «Временно нет в наличии».',
  importStockShops: 'Столбцы остатков (магазин)',
  importTotal: 'Всего строк',
  importWillCreate: 'Будет создано',
  importWillUpdate: 'Будет обновлено',
  importErrors: 'Ошибки',
  importRow: 'Строка',
  importColumn: 'Столбец',
  importValue: 'Значение',
  importAction: 'Действие',
  importRecognized: 'Распознанные столбцы',
  importIgnored: 'Нераспознанные заголовки',
  importPreview: 'Предпросмотр',
  importApply: 'Применить',
  importApplied: 'Применено.',
  importSkipHint: (n: number): string => `${String(n)} строк с ошибками будут пропущены`,

  refSettings: 'Настройки',
  refCategories: 'Категории',
  refBrands: 'Бренды',
  refPublic: 'Публичная',
  refYes: 'Да',
  refNo: 'Нет',
  refActive: 'Активна',
  refInactive: 'Скрыта',
  refHide: 'Скрыть',
  refShow: 'Показать',
  refDelete: 'Удалить',
  refAdd: 'Добавить',
  refAddCategory: 'Новая категория',
  refAddBrand: 'Новый бренд',
  refNameUz: 'Название (узбекский)',
  refBrandName: 'Название бренда',
  refCountry: 'Страна',
  refNoParent: 'Корневая категория',
  refSlugPreview: 'Slug',
  refProductCount: (n: number): string => `${String(n)} товаров`,
  refInvalidType: (type: string): string => `Тип значения не совпадает: ожидается ${type}`,

  refVehicles: 'Автомобили',
  refSynonyms: 'Синонимы',
  refBanners: 'Баннеры',
  refMakeName: 'Название марки',
  refAddMake: 'Добавить марку',
  refModels: 'Модели',
  refAllMakes: 'Все марки',
  refAddModel: 'Новая модель',
  refModelName: 'Название модели',
  refYearFrom: 'С года',
  refYearTo: 'По год',
  refAliases: 'Варианты написания',
  refAliasesHint: 'Через запятую: treker, трекер, tacker. Это поле попадает в поисковый индекс.',
  refPickMake: 'Сначала выберите марку',
  refYearsInvalid: 'Неверный диапазон лет',
  refAddSynonym: 'Новый синоним',
  refTerm: 'Термин',
  refSynonymValues: 'Синонимы (через запятую)',
  refSynonymsHint:
    'Каждое изменение сразу переносится в поисковый индекс. Заполняется по журналу запросов без результатов.',
  refAddBanner: 'Новый баннер',
  refEditBanner: 'Редактировать баннер',
  refSaveBanner: 'Сохранить изменения',
  refBannerTitle: 'Заголовок',
  refBannerSubtitle: 'Описание',
  refBannerBadge: 'Метка',
  refBannerTitleUz: 'Заголовок (узбекский)',
  refBannerTitleRu: 'Заголовок (русский, необязательно)',
  refBannerSubtitleUz: 'Описание (узбекский)',
  refBannerSubtitleRu: 'Описание (русский, необязательно)',
  refBannerBadgeUz: 'Метка (узбекский)',
  refBannerBadgeRu: 'Метка (русский, необязательно)',
  refBannerStartsAt: 'Начало показа (необязательно)',
  refBannerEndsAt: 'Окончание показа (необязательно)',
  refBannerSort: 'Порядок показа (0–9999, необязательно)',
  refBannerDateInvalid: 'Начало показа должно быть раньше окончания.',
  refBannerSortInvalid: 'Порядок должен быть целым числом от 0 до 9999.',
  refBannerLink: 'Куда ведёт при нажатии',
  refBannerLinkNone: 'Никуда (только реклама)',
  refBannerLinkProduct: 'На страницу товара',
  refBannerLinkCategory: 'В категорию',
  refBannerLinkCatalog: 'В весь каталог',
  refBannerLinkSearch: 'На результаты поиска',
  refBannerLinkChosen: 'Выбранный товар',
  refBannerFillFromProduct: 'Заполнить текст баннера из товара',
  refBannerLinkProductSearch: 'Найдите товар по артикулу, названию или OEM-номеру',
  refBannerLinkNoProducts: 'Активный товар не найден.',
  refBannerLinkPickCategory: 'Выберите категорию',
  refBannerLinkSearchPlaceholder: 'Например: амортизатор',
  refBannerLinkIncomplete: 'Выберите цель ссылки или оставьте «Никуда».',
  refCategoryImage: 'Изображение категории',
  refCategoryImageUpload: 'Загрузить изображение',
  refCategoryImageReplace: 'Заменить изображение',
  refCategoryImageRemove: 'Убрать изображение',
  refCategoryImageHint:
    'Квадрат, не менее 96×96 px (рекомендуется 256×256), лучше PNG/WebP с прозрачностью. Без изображения показывается иконка.',
  refCategoryImageDone: 'Изображение категории сохранено',
  refCategoryImageRemoved: 'Изображение категории убрано',
  refBannerImage: 'Изображение баннера',
  refBannerImageUpload: 'Загрузить изображение',
  refBannerImageReplace: 'Заменить изображение',
  refBannerImageRemove: 'Убрать изображение',
  refBannerImageHint:
    'Рекомендуется: 1200×620 px (минимум 600×300), JPG/PNG/WebP, до 12 МБ. Размещайте товар в правой половине: слева будут заголовок и цена.',
  refBannerImageType: 'Можно загрузить только JPG, PNG, WebP или AVIF.',
  refBannerImageTooBig: 'Файл слишком большой (не более 12 МБ).',
  refBannerImageEmpty:
    'Выберите файл JPG, PNG или WebP. На следующем шаге его можно будет обрезать.',
  refBannerImagePending: 'Новое изображение — загрузится при нажатии «Сохранить».',
  refBannerImageFailedAfterSave:
    'Баннер сохранён, но изображение не загрузилось. Откройте баннер и выберите изображение снова.',
  refBannerColor: 'Цвет и иконка (если нет изображения)',
  refBannerColorNone: 'Стандартный',
  refBannerColorEngine: 'Двигатель',
  refBannerColorBrakes: 'Тормоза',
  refBannerColorOils: 'Масла',
  refBannerColorElectric: 'Электрика',
  refBannerColorTires: 'Шины',
  refBannerColorAccess: 'Аксессуары',
  refBannersLead:
    'Большие рекламные карточки на главной. Показываются в порядке списка: верхний — первый.',
  refBannersCacheNote:
    'Изменения видны клиентам через 1–5 минут: приложение ненадолго запоминает данные.',
  refBannersEmpty: 'Баннеров пока нет',
  refBannersEmptyHint:
    'Баннер — большая рекламная карточка на главной: изображение, заголовок и переход к товару или категории. Добавьте первый.',
  refBannerStateLive: 'Показывается клиентам',
  refBannerStateHidden: 'Скрыт',
  refBannerStateScheduled: 'Ещё не начался',
  refBannerStateExpired: 'Срок истёк',
  refBannerEditShort: 'Изменить',
  refBannerNoImage: 'Без изображения',
  refBannerNoLink: 'Без ссылки',
  refBannerFrom: 'с',
  refBannerDeleteTitle: 'Удалить баннер?',
  refBannerDeleteBody:
    'Баннер удалится навсегда, вернуть его нельзя. Если нужно убрать временно — нажмите «Скрыть»: потом его можно показать снова.',
  refBannerEditorClose: 'Закрыть',
  refBannerPreview: 'Так увидит клиент в приложении',
  refBannerPreviewTitle: 'Заголовок баннера',
  refBannerStep1: 'Изображение',
  refBannerStep1Hint: 'Фон баннера. Необязательно: без изображения баннер будет цветным.',
  refBannerStep2: 'Текст',
  refBannerStep2Hint:
    'Заголовок — коротко и ясно (3–6 слов). Если русский текст пуст, русскоязычный клиент увидит узбекский.',
  refBannerStep3: 'Что будет при нажатии',
  refBannerStep3Hint: 'Переход к товару, категории или поиску. Не нужно — «Никуда».',
  refBannerStep4: 'Когда и в каком порядке показывать',
  refBannerStep4Hint:
    'Без дат баннер показывается всегда. Порядок: меньшее число — раньше (пусто — в конец).',
  refBannerNeedTitle: 'Введите заголовок (узбекский).',
  refBannerDiscardTitle: 'Изменения не сохранены. Выйти?',
  refBannerDiscard: 'Выйти',
  refBannerKeepEditing: 'Продолжить',
  refUntil: 'до',

  refShops: 'Магазины',
  refZones: 'Зоны доставки',
  refStatuses: 'Статусы',
  refAddShop: 'Новый магазин',
  refShopCode: 'Код',
  refShopCodeHint:
    'Код ТОЛЬКО заглавные буквы, цифры и подчёркивание: TASHKENT_SERGELI. Не меняется и используется во внешних системах.',
  refPickRegion: 'Выберите регион',
  refAddress: 'Адрес',
  refAddZone: 'Новая зона',
  refZoneService: 'Услуга (например: свой курьер)',
  refZoneEta: 'Срок (например: 1-2 дня)',
  refZonesHint:
    'В зоне НЕТ ЦЕНЫ — условия доставки согласуются с оператором по телефону. Здесь только название услуги и примерный срок.',
  refNoRegions: 'Регионы не привязаны',
  refFallback: 'Резервная',
  refStatusesHint:
    'Настраиваются подпись и push. Код статуса, поток и граф переходов НЕ РЕДАКТИРУЮТСЯ — граф это и есть поток заказа.',
  refTerminal: 'конечный',
  refNotifyOn: 'Push включён',
  refNotifyOff: 'Push выключен',
  refNotifyDisable: 'Выключить push',
  refNotifyEnable: 'Включить push',

  analyticsDays: (n: number): string => `${String(n)} дн.`,
  analyticsTotals: 'Итого',
  analyticsRevenue: 'Выручка',
  analyticsRegions: 'Регионы',
  analyticsRegionsHint: 'Заказов много, а магазина нет — основание открыть точку.',
  analyticsHasShop: 'Магазин есть',
  analyticsNoShop: 'Магазина нет',
  analyticsEmptySearches: 'Запросы без результатов',
  analyticsEmptySearchesHint:
    'Товары, которые клиенты хотели купить, но не нашли. Из этого строится план ассортимента.',
  analyticsGarage: 'Машины в гараже',
  analyticsGarageHint: 'Показывает, для каких моделей нужен товар.',
  analyticsQuery: 'Запрос',
  analyticsCount: 'Количество',
  analyticsLastAt: 'Последний раз',
  analyticsEmpty: 'За этот период данных нет.',

  auditHint:
    'Кто что сделал. Запись не удаляется и не редактируется — журнал, который можно изменить, не может быть доказательством.',
  auditAt: 'Время',
  auditAction: 'Действие',
  auditEntityCol: 'Объект',
  auditChanges: 'Что изменилось',
  auditEmpty: 'Записей нет.',

  usersCreate: 'Создать сотрудника',
  usersCreateHint:
    'Сотрудник не регистрируется сам — его создаёт Owner. Выдача и снятие роли попадают в журнал аудита.',
  usersPasswordHint: 'Минимум 12 символов, заглавная и строчная буквы и цифра.',
  usersLoginInvalid: 'Логин 3–64 символа: строчные латинские буквы, цифры и _.',
  usersLoginTaken: 'Этот логин занят. Введите другой логин.',
  usersNameInvalid: 'Введите имя (не более 80 символов).',
  usersPasswordInvalid: 'Пароль 12–128 символов: строчные и заглавные буквы и цифра.',
  usersRoleRequired: 'Выберите одну роль.',
  usersShopRequired: 'Выберите магазин для этой роли.',
  usersLogin: 'Логин',
  usersName: 'Имя',
  usersState: 'Состояние',
  usersActive: 'Активен',
  usersInactive: 'Неактивен',
  usersRoles: 'Роли',
  usersNoRole: 'Ролей нет',
  usersAddRole: 'Добавить роль',
  usersShop: 'Магазин',
  usersShopHint: 'Курьер работает только с отправлениями этого магазина.',
  usersRoleUnclassified: 'не классифицирована',
  usersSearch: 'Логин или имя',
  usersEmpty: 'Сотрудник не найден.',

  dashboardSubtitle: (role: string): string => `как ${role}`,
  dashboardRevenue: 'Оборот',
  dashboardRevenueHint: 'всего',
  dashboardProfit: 'Валовая прибыль',
  dashboardProfitHint: 'Видит только Owner',
  dashboardClosed: 'Закрыто',
  dashboardMargin: (percent: number): string => `маржа ${String(percent)}%`,
  dashboardNewOrders: (n: number): string => `${String(n)} новых`,
  dashboardActiveProducts: 'Активные товары',
  dashboardDrafts: (n: number): string => `${String(n)} черновиков`,
  dashboardAttention: 'Требует внимания',
  dashboardAllClear: 'Пока всё в порядке.',
  dashboardTop: 'Больше всего продано',
  dashboardNoSales: 'Продаж пока нет.',
  dashboardAlert: (kind: string, n: number): string =>
    ({
      NEW_ORDERS: `${String(n)} новых заказов не подтверждены`,
      PENDING_PAYMENTS: `${String(n)} платежей не подтверждены`,
      EMPTY_SEARCHES: `${String(n)} запросов без результата`,
      OUT_OF_STOCK: `${String(n)} активных товаров нигде нет в наличии`,
    })[kind] ?? String(n),
  consignmentsCount: (n: number): string => `${String(n)} шт.`,
  consignmentsHint:
    'Партия — одна машина, один инвойс. При смене статуса переезжают ВСЕ отправления внутри.',
  consignmentsEmpty: 'Партий нет.',
  consignmentsEmptyHint:
    'Когда груз приходит из Китая, открывается партия и к ней привязываются отправления.',
  consignmentInvoice: 'Инвойс',
  consignmentSupplier: 'Поставщик',
  consignmentShipments: 'Отправлений',
  consignmentMove: 'Переместить',
  consignmentEnd: 'Последний этап',
  consignmentResult: 'Результат',
  consignmentMoved: (moved: number, notified: number): string =>
    `${String(moved)} отправлений перемещено, ${String(notified)} уведомлений отправлено.`,
  consignmentSkipped: (n: number): string => `${String(n)} отправлений не перемещено:`,
  consignmentSkipReason: (reason: string): string =>
    reason === 'FORBIDDEN' ? 'нет прав' : 'из этого статуса такой переход невозможен',
  dashboardAlertHint: (kind: string): string =>
    ({
      NEW_ORDERS: 'Оператор должен позвонить',
      PENDING_PAYMENTS: 'Кто-то должен подтвердить получение денег',
      EMPTY_SEARCHES: 'Нужно пополнить ассортимент или теги',
      OUT_OF_STOCK: 'Внесите остаток или переведите на заказ (PRE_ORDER)',
    })[kind] ?? '',
  auditEntity: (entity: string): string =>
    ({
      Product: 'Товар',
      Payment: 'Платёж',
      Shipment: 'Отправление',
      User: 'Пользователь',
      Order: 'Заказ',
      Setting: 'Настройка',
    })[entity] ?? entity,
};

export const MESSAGES: Readonly<Record<Locale, Messages>> = { UZ, RU };

export function messages(locale: Locale): Messages {
  return MESSAGES[locale];
}

/** Guruh yorlig'i — kontraktdagi ta'rifdan, tilga qarab. */
export function bucketLabel(bucket: WorkQueueBucket, locale: Locale): string {
  const def = WORK_QUEUE_BUCKET_DEFS.find((d) => d.bucket === bucket);
  if (def === undefined) return bucket;
  return locale === 'RU' ? def.labelRu : def.labelUz;
}

/**
 * "Qancha kutdi" — inson o'qiydigan shaklda.
 *
 * Aniq daqiqa operatorga kerak emas; unga kerak bo'lgani —
 * "bu bugungi" yoki "bu uch kundan beri turibdi".
 */
export function waitingText(since: string, now: number, locale: Locale): string {
  const t = messages(locale);
  const elapsed = now - new Date(since).getTime();
  // Kelajakdagi vaqt (soatlar farqi, sinov ma'lumoti) manfiy chiqmasin.
  const minutes = Math.max(0, Math.floor(elapsed / 60_000));

  if (minutes < 60) return t.waitingMinutes(minutes);
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return t.waitingHours(hours);
  return t.waitingDays(Math.floor(hours / 24));
}
